module.exports = __webpack_public_path__ + "static/media/bulk_consignment_upload.d4eded0d.csv";